<template>
    <div class="table-list lease-finished">
        <contract-release :cid="contractId" :isTool="false" :obj="filterByWord[selectedIndex]"></contract-release>
        <get-lease-evaluation :contractCid="filterByWord[selectedIndex]?filterByWord[selectedIndex].contractCid:null"></get-lease-evaluation>
        <modal class="biz-set-evaluation" :display="modalState.setEvaluation" @modalStatus="closeModal('setEvaluation')" >
            <alarm-msg-white type="ERROR" :msg="alarm.error.msg" :count="alarm.error.count" :showAlarm="alarm.error.status" @timeOut="alarm.error.status=false"></alarm-msg-white>
            <h1>評價房客</h1>
            <div class="wrap">
                <div class="tenant">
                    <img src="@/assets/img/icon/user_shot_black.svg" alt="">
                    {{filterByWord[selectedIndex]?filterByWord[selectedIndex].tenantName:''}}
                </div>
                <div class="contract-info">
                    <div>聯絡方式：{{filterByWord[selectedIndex]?filterByWord[selectedIndex].tenantPhone:''}}</div>
                    <div>租期：{{converseDate(filterByWord[selectedIndex]?filterByWord[selectedIndex].contractBeginTime:'')}} - {{converseDate(filterByWord[selectedIndex]?filterByWord[selectedIndex].contractEndTime:'')}}</div>
                    <div>押金：兩個月</div>
                </div>
                <div class="rate-wrap">
                    <div class="title">真實完整敘述，杜絕不良房客</div>
                    <div class="rate" ref="stars">
                        <img @click="setStars(1)" src="@/assets/img/component/evaluation/star_golden_large.svg" />
                        <img @click="setStars(2)" src="@/assets/img/component/evaluation/star_golden_large.svg" />
                        <img @click="setStars(3)" src="@/assets/img/component/evaluation/star_golden_large.svg" />
                        <img @click="setStars(4)" src="@/assets/img/component/evaluation/star_golden_large.svg" />
                        <img @click="setStars(5)" src="@/assets/img/component/evaluation/star_golden_large.svg" />
                    </div>
                </div>
                <div class="house-rent">
                    <label class="button-font input-label">
                        <div class="title">
                        </div>
                        <span v-show="error.comment" class="error-with-title">{{error.comment}}</span>
                    </label>
                    <div class="input-arear">
                        <textarea :class="{error: error.comment}" v-model="evaluationParams.comment" name="" id="" cols="30" rows="10" placeholder="歡迎留下評價內容"></textarea>
                        <span class="des-count"><span class="count">{{evaluationParams.comment?evaluationParams.comment.length:'0'}}</span>/200</span>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="setEvaluation(), $analyticsBiz.logEvent('送出新增評價', { screen_name: '送出新增評價'})">評價</button>
            </div>
        </modal>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="contract-date">租約起訖日</span>
            <span class="address">地址</span>
            <span class="lease-type">租約類型</span>
            <span class="lease-status">租約狀態</span>
            <span class="pay-status">繳款狀態</span>
            <span class="tenant">租客</span>
            <span class="agent">業務</span>
            <span class="rent">租金</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-if="isLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if="filterByWord.length == 0 && leaseFinishedList.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div>
            <div v-else-if="leaseFinishedList.length == 0" class="is-empty">0 筆資料</div>
            <ul v-else>
                <li v-for="(house,index) in filterByWord" :key="index">
                    <span class="contract-date">{{converseDate(house.contractBeginTime)}} - {{converseDate(house.contractEndTime)}}</span>
                    <span class="address">
                        {{house.address}}
                        <!-- {{house.address.length >= 17?compressWord(house.address, 17):house.address}}
                        <div v-if="house.address.length >= 17" class="full-word">
                            <span>
                                {{house.address}}
                            </span>
                        </div> -->
                    </span>
                    <span class="lease-type" v-if="house.contractType === 'ELECTRONIC_CONTRACT'">一般合約</span>
                    <span class="lease-type" v-else>紙本合約</span>
                    <span class="lease-status">
                        <span v-if="house.contractStatus === 'TENANT_FINISHED_CONTRACT'">提前退租</span>
                        <span v-if="house.contractStatus === 'TENANT_REJECT_CONTRACT' || house.contractStatus === 'TENANT_REJECT_PAPER_CONTRACT' || house.contractStatus === 'TENANT_NOT_CONFIRM_IN_TIME' || house.contractStatus === 'CONTRACT_DEPOSIT_IS_NOT_PAID_IN_TIME'">租客拒絕</span>
                        <span v-if="house.contractStatus === 'LANDLORD_NOT_CONFIRM_IN_TIME' || house.contractStatus === 'LANDLORD_REJECT_CONTRACT'">房東拒絕</span>
                        <span v-if="house.contractStatus === 'CONTRACT_FINISHED'">正常結束</span>
                    </span>
                    <span class="pay-status">
                        <span class="red" v-if="house.billStatus === 'OVERDUE'">{{house.statusDesc.overdueCount}} 筆欠款</span>
                        <span class="blue" v-if="house.billStatus === 'UNPAID'">{{house.statusDesc.uncreatedBillBeginDate}}~{{house.statusDesc.uncreatedBillEndDate}}尚未收租</span>
                        <span class="gray" v-if="house.billStatus === 'COMPLETELY_PAID'">正常</span>
                    </span>
                    <span class="tenant">{{house.tenantName}}</span>
                    <span class="agent">{{house.agentName}}</span>
                    <span class="rent">{{toCurrency(house.rentPrice)}}</span>
                    <span class="action">
                        <dot-dropmenu>
                            <ul >
                                <li v-if="house.contractType === 'PAPER_CONTRACT'" @click="getContractPDF(house.contractCid), $analyticsBiz.logEvent('查看紙本合約', { screen_name: '查看紙本合約'})">紙本合約</li>
                                <li v-else @click="getContract(house.contractCid), $analyticsBiz.logEvent('查看合約', { screen_name: '查看合約'})">查看合約</li>
                                <li v-if="house.isRated === false  && bizAuth.createTenantRate.hasRight" @click="setEvaluationClickEvent(index), $analyticsBiz.logEvent('新增評價', { screen_name: '新增評價'})" >新增評價</li>
                                <li v-if="house.isRated === true && bizAuth.viewTenantRate.hasRight" @click="getEvaluation(index), $analyticsBiz.logEvent('查看評價', { screen_name: '查看評價'})" >查看評價</li>
                                <li @click="toBillDetail(house.address), $analyticsBiz.logEvent('帳單紀錄', { screen_name: '帳單紀錄'})"
                                    v-if="bizAuth.viewBillRecord.hasRight">帳單紀錄</li>
                                <li @click="contractId = house.contractCid, selectedIndex = index, releaseContract()"
                                    >退租明細</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import getLeaseEvaluation from '@/components/bussiness/widges/modals/getLeaseEvaluation.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import alarmMsgWhite from '@/components/bussiness/widges/alarms/alarmMsgWhite.vue';
import contractRelease from '@/components/bussiness/widges/modals/contractRelease.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';
import { mapGetters } from 'vuex'

import { 
    apiBizSetEvaluation,
    } from "@/apis/api.js"; 
import { 
    getContractPDF
    } from "@/apis/company/leaseMgt.js"; 
export default {
    data () {
        return{
            // leaseFinishedList: [],
            selectedIndex: 0,
            evaluationParams: {
                "tenantCid" : null,
                "contractCid" : null,
                "rate" : 5,
                "comment" : null
            },
            filterEmpty: false,
            leaseDataEmpty: false,
            leaseDataError: false,
            contractId: null,
            isLoading: true,
            modalState: {
                setEvaluation: false,
            },
            alarm: {
                success:{
                    status: false,
                    msg: null,
                    count: 2000
                },
                error:{
                    status: false,
                    msg: null,
                    count: 2000
                }
            },
            error: {
                comment: null
            }
        }
    },
    mounted () {
        this.getLeaseFinishedList()
    },
    watch: {
        'evaluationParams.comment': function (val){
            let wordLimit = this.checkStringLessThanNum(val, 200)
            if(!wordLimit){
                this.error.comment = '限制字數200字'
            }else{
                this.error.comment = null
            }
        }
    },  
    methods: {
        setFilterDefault: function () {
            this.$store.dispatch('setBizLeaseFinishedFilterDefault')
        },
        getLeaseFinishedList: function () {
            this.isLoading = true
            this.loadLeaseFinishedPage(1)
        },
        // 逐頁抓取並累加：第 1 頁一到就先顯示，其餘頁在背景繼續載入並自動接上
        // 有 totalPage 就照總頁數抓；純陣列(未知總頁數)則抓到某頁回空為止，上限 100 頁避免無限迴圈
        loadLeaseFinishedPage: function (page) {
            this.$store.dispatch('getBizLeaseFinishedMgtList', page)
            .then((info)=>{
                // 第一頁回來就關掉 loading，先讓使用者看到資料
                if( page === 1 ){
                    this.isLoading = false
                }
                let hasMore = info.totalPage > 0
                    ? page < info.totalPage
                    : (info.count > 0 && page < 100)
                if( hasMore ){
                    this.loadLeaseFinishedPage(page + 1)
                }
            })
        },
        getContract: function (cid) {
            window.open('/contractPaper?cid='+cid, "_blank")
        },
        getContractPDF: function (cid) {
            let params = {
                contractCid: cid
            }
            getContractPDF(params)
            .then( res => {
                if(res.status == 200){
                //    window.open(res.data);
                    // var blob = new Blob([res.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf;charset-UTF-8' }));
                    window.open(url);
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        releaseContract: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizContractRelease'})
        },
        // toContractDetail: function (cid) {
        //     window.open('/landlord/leasemanagement/contractdetail?cid='+cid+'&pos=bill')
        // },
        closeModal: function (type) {
            this.$store.commit('modalStatus/set_modal_mode', false)
            if( type == 'setEvaluation' ){
                this.modalState.setEvaluation = false
                
            }
        },
        setEvaluation: function (){
            let data = this.evaluationParams
            console.log(data)
            if(data.comment){
                if(!this.error.comment){
                    apiBizSetEvaluation(data)
                    .then(res => {
                        console.log(res)
                        if(res.data.status == "SUCCESS"){
                            this.$store.dispatch('setAlarmStatus', {status: true,title: '評價成功',type: 'success'})
                            this.getLeaseFinishedList()
                        }else{
                            this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                        }
                        this.closeModal('setEvaluation')
                    })
                    .catch(err => {
                        console.log(err)
                        this.$store.dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                    })
                }
            }else{
                this.alarm.error.msg = '尚未填寫評價'
                this.alarm.error.status = true
            }
            
        },
        getEvaluation: function (index){
            this.selectedIndex = index
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizLeaseEvaluation'})
        },
        setEvaluationClickEvent: function (index) {
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
            this.selectedIndex = index
            this.modalState.setEvaluation = true
            this.evaluationParams.comment = null
            this.evaluationParams.tenantCid = this.filterByWord[this.selectedIndex].tenantCid
            this.evaluationParams.contractCid = this.filterByWord[this.selectedIndex].contractCid
        },
        setStars: function (rate) {
            // console.log(this.$refs)
            this.evaluationParams.rate = rate
            if(this.$refs.stars.children){
                let stars = this.$refs.stars.children
                for (let i = 1; i < 5; i++) {
                    const star = stars[i];
                    if(i<rate){
                        star.src = require('@/assets/img/component/evaluation/star_golden_large.svg')
                    }else{
                        star.src = require('@/assets/img/component/evaluation/star_gray_large.svg')
                    }
                }
            }
        },
        toBillDetail: function (data) {
            let routerUrl = this.$router.resolve({ name: 'billMgt', query: { 'filterWord': data }})
            window.open(routerUrl.href, '_blank');
        },
        converseDate: function (date) {
            // console.log(date)
            var formatDate = [];
            var date = new Date(date);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            formatDate[5] = (Array(2).join(0)+date.getSeconds()).slice(-2);
            //月及天兩位數
            formatDate[6] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[7] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            // if(formatDate[3] - 8 < 0){
            //     formatDate[3] = 24+(formatDate[3]-8);
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }else{
            //     formatDate[3] = formatDate[3]-8;
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }
            return formatDate[0]+'-'+formatDate[6]+'-'+formatDate[7]/*' '+formatDate[3]+':'+formatDate[4]+':'+formatDate[5]*/;
        }
        
    },
    computed: {
        fileterByCounty: function () {
            return this.leaseFinishedList.filter((item) => {
                if(this.filterQuery.county){
                    if(item.county.includes(this.filterQuery.county) == true){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        fileterByDistrict: function () {
            return this.fileterByCounty.filter((item) => {
                if( this.filterQuery.district){
                    if(item.district.includes(this.filterQuery.district) == true){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByRent: function () {
            return this.fileterByDistrict.filter((item) => {
                if( this.filterQuery.rent ){
                    if( this.filterQuery.rent[0] <= item.rentPrice && this.filterQuery.rent[1] >= item.rentPrice ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByContractDate: function () {
            return this.filterByRent.filter((item) => {
                // console.log(item)
                if( this.filterQuery.leaseTerm[0] && this.filterQuery.leaseTerm[1] ){
                    let rentDateStart = Date.parse(item.contractBeginTime).valueOf(),
                        rentDateEnd = Date.parse(item.contractEndTime).valueOf(),
                        filterRentDateStart = Date.parse(this.filterQuery.leaseTerm[0]).valueOf(),
                        filterRentDateEnd = Date.parse(this.filterQuery.leaseTerm[1]).valueOf()
                        
                    if( filterRentDateStart <= rentDateStart && rentDateEnd <= filterRentDateEnd ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByGroup: function () {
            return this.filterByContractDate.filter((item) => {
                if(this.filterQuery.group){
                    if(item.groupName == this.filterQuery.group ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterBySales: function () {
            return this.filterByGroup.filter((item) => {
                if(this.filterQuery.member){
                    if(item.landlordName == this.filterQuery.member ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByLeaseType: function () {
            return this.filterBySales.filter((item) => {
                if(this.filterQuery.type == 'PAPER'){
                    if(item.isPaperContract){
                        return item
                    }
                }else{
                    if(!item.isPaperContract){
                        return item
                    }
                }
            });
        },
        filterByStatus: function () {
            return this.filterByLeaseType.filter((item) => {
                if(this.filterQuery.status){
                    if(item.billStatus == this.filterQuery.status ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterByStatus.filter((leaseItem) => {
                if( this.filterWord ){
                    if( leaseItem.tenantName.includes(this.filterWord) || leaseItem.address.includes(this.filterWord) || leaseItem.tenantPhone.includes(this.filterWord) ){
                        return leaseItem
                    }
                }else{
                    return leaseItem
                }
            });
        },
        ...mapGetters({
            leaseFinishedList: 'GET_BIZ_LEASE_FINISHED_MGT_LIST',
            totalPage: 'GET_BIZ_LEASE_FINISHED_MGT_TOTAL_PAGE',
            filterWord: 'GET_BIZ_LEASE_FINISHED_MGT_FILTER_WORD',
            filterQuery: 'GET_BIZ_LEASE_FINISHED_MGT_FILTER_QUERY',
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        getLeaseEvaluation,
        Modal,
        AlartMsg,
        alarmMsgWhite,
        contractRelease,
        tableLoading
    }
}
</script>
<style lang="scss">
    .table-list.lease-finished{
        // .table-list-title .contract-date:before{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     top: 2px;
        //     border-style: solid;
        //     border-width: 0 2.5px 4px 2.5px;
        //     border-color: transparent transparent #525956 transparent;
        // }
        // .table-list-title .contract-date:after{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     bottom: 1px;
        //     border-style: solid;
        //     border-width: 4px 2.5px 0 2.5px;
        //     border-color: #525956 transparent transparent transparent;
        // }
            
        .table-list-title .contract-date,
        .table-list-body ul li .contract-date{
            position: relative;
            width: 160px;
            margin-right: 30px;
        }
        .table-list-title .address,
        .table-list-body ul li .address{
            width: 235px;
            margin-right: 20px;
        }
        .table-list-body ul li .address{
            line-height: 1.5;
        }
        .table-list-title .lease-type,
        .table-list-body ul li .lease-type{
            width: 56px;
            margin-right: 30px;
        }
        .table-list-title .lease-status,
        .table-list-body ul li .lease-status{
            width: 56px;
            margin-right: 30px;
        }
        .table-list-title .pay-status,
        .table-list-body ul li .pay-status{
            width: 184px;
            margin-right: 30px;
        }
        .table-list-body ul li .pay-status{
            >span{
                border-radius: 4px;
                font-weight: 500;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 9px 13px;
            }
            .red{
                background-color: rgba(252, 113, 113, 0.1);
                color: #fc7171;
            }
            .gray{
                background-color: #f3f3f3;
                color: #676362;
            }
            .blue{
                background-color: rgba(79, 181, 192, 0.1);
                color: #71aae5;
            }
        }
        .table-list-title .tenant,
        .table-list-body ul li .tenant{
            width: 42px;
            margin-right: 30px;
            word-break: break-all;
        }
        .table-list-title .agent,
        .table-list-body ul li .agent{
            width: 42px;
            margin-right: 30px;
        }
        .table-list-title .rent,
        .table-list-body ul li .rent{
            width: 43px;
            text-align: right;
            margin-right: 30px;
        }
       
        
    }
    // @media screen and (max-width: 1280px){
    //     .table-list.lease-finished{
    //         .table-list-title .contract-date,
    //         .table-list-body ul li .contract-date{
    //             margin-right: 30px;
    //         }
    //         .table-list-title .type,
    //         .table-list-body ul li .type{
    //             margin-right: 47px;
    //         }
    //         .table-list-title .tanant,
    //         .table-list-body ul li .tanant{
    //             margin-right: 47px;
    //         }
    //         .table-list-title .phone,
    //         .table-list-body ul li .phone{
    //             margin-right: 47px;
    //         }
    //         .table-list-title .address,
    //         .table-list-body ul li .address{
    //             margin-right: 47px;
    //         }
    //         .table-list-title .status,
    //         .table-list-body ul li .status{
    //             margin-right: 47px;
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/leaseMgt/leaseFinished/LeaseFinishedList.vue